<template>
  <div class="meta-area" data-track-skip>
    <div
      class="meta-area__content"
      :class="{ 'meta-area__content--no-image': noImage }"
    >
      <magazine-meta-navigation
        v-if="navigationItems"
        :links="navigationItems"
      />
      <magazine-registration
        :registration-form-formid="registrationFormFormid"
        :registration-form-formstart="registrationFormFormstart"
        :registration-form-submit-url="registrationFormSubmitUrl"
        :social-links="socialLinks"
      />
    </div>
  </div>
</template>

<script>
import MagazineMetaNavigation from './MagazineMetaNavigation'
import MagazineRegistration from './MagazineRegistration'

export default {
  name: 'MagazineMeta',

  components: {
    MagazineMetaNavigation,
    MagazineRegistration,
  },

  props: {
    noImage: Boolean,
    registrationFormSubmitUrl: {
      type: String,
      default: '',
    },
    registrationFormFormid: {
      type: String,
      default: '',
    },
    registrationFormFormstart: {
      type: String,
      default: '',
    },
    socialLinks: {
      type: String,
      default: '',
    },
    navigationList: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      navigationItems: [],
    }
  },

  mounted() {
    try {
      this.navigationItems = JSON.parse(this.navigationList)
    } catch (e) {
      console.error('Navigation items parse error ', e)
    }
  },
}
</script>

<style lang="postcss">
.meta-area {
  width: 100%;
  padding: 0;
  display: flex;
  position: relative;
  z-index: 99;
  background-color: white;
  margin-top: var(--spacing-2);

  &__content {
    width: 100%;
    margin: 0 auto;
    display: inline-flex;
    flex-direction: column-reverse;

    &--no-image {
      position: relative;
    }
  }
}

@media (max-width: 1200px) {
  .meta-area__content {
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
  }
}

@media (max-width: 860px) {
  .meta-area__content {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (--xs) {
  .meta-area {
    margin-top: var(--spacing-4);

    &__content {
      gap: var(--spacing-2);
    }
  }
}

@media (--md) {
  .meta-area__content {
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-8);
  }
}

@media (--xl) {
  .meta-area__content {
    flex-direction: row;
    width: 1100px;
    justify-content: flex-end;
  }
}
</style>
